module.exports = __webpack_public_path__ + "img/team-seadevils.25419a07.png";